import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const BlogIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.7305 5C12.7305 4.46957 12.5198 3.96086 12.1447 3.58579C11.7696 3.21071 11.2609 3 10.7305 3H4.73047C4.46525 3 4.2109 3.10536 4.02336 3.29289C3.83583 3.48043 3.73047 3.73478 3.73047 4V18C3.73047 18.2652 3.83583 18.5196 4.02336 18.7071C4.2109 18.8946 4.46525 19 4.73047 19H10.7305C11.2609 19 11.7696 19.2107 12.1447 19.5858C12.5198 19.9609 12.7305 20.4696 12.7305 21M12.7305 5C12.7305 4.46957 12.9412 3.96086 13.3163 3.58579C13.6913 3.21071 14.2 3 14.7305 3H20.7305C20.9957 3 21.25 3.10536 21.4376 3.29289C21.6251 3.48043 21.7305 3.73478 21.7305 4V18C21.7305 18.2652 21.6251 18.5196 21.4376 18.7071C21.25 18.8946 20.9957 19 20.7305 19H14.7305C14.2 19 13.6913 19.2107 13.3163 19.5858C12.9412 19.9609 12.7305 20.4696 12.7305 21M12.7305 5V21M7.73047 7H8.73047M7.73047 11H8.73047M16.7305 7H17.7305M16.7305 11H17.7305M16.7305 15H17.7305"
          stroke="#676979"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
